import { execa } from 'execa'

import { getDependencyInstaller, getPackageManager } from '@utils/getPackageManager'
import { handleError } from '@utils/handleError'
import { spinner } from '@utils/spinner'

export const installDependencies = async (projectDir: string, dependencies: string[], silent?: boolean) => {
  if (!dependencies.length) return
  const packageManager = await getPackageManager(projectDir)
  const packageManagerName = packageManager.name
  const dependencyInstaller = await getDependencyInstaller(projectDir)
  const dependencySpinner = spinner('Installing dependencies', { silent }).start()
  try {
    await execa(packageManagerName, [dependencyInstaller, '--legacy-peer-deps', ...dependencies], {
      cwd: projectDir,
      stdio: 'ignore',
    })
    dependencySpinner.succeed()
  } catch (error) {
    dependencySpinner.fail()
    handleError('Failed to install dependencies.')
  }
}
